import type { VehicleListing } from '@cinch-nx/data-search'
import { IconNames } from '@cinch-labs/design-system'
import { SpecsListItem } from '../../components/vehicle-card/components'

type VehicleSpecArgs = Pick<
  VehicleListing,
  | 'fuelType'
  | 'mileage'
  | 'transmissionType'
  | 'modelYear'
  | 'rangeInMiles'
  | 'rangeType'
>

const formatToSentenceCase = (input: string) =>
  input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()

const formatFuelType = (input: string) =>
  input.toUpperCase() === 'LPG'
    ? input.toUpperCase()
    : formatToSentenceCase(input)

export const formatVehicleSpecs = (vehicle: VehicleSpecArgs) => {
  const specs: SpecsListItem[] = [
    { label: 'Vehicle Year', value: vehicle.modelYear },
    {
      label: 'Mileage',
      value: vehicle.mileage
        ? `${Intl.NumberFormat().format(vehicle.mileage)} miles`
        : '',
    },
    { label: 'Fuel Type', value: formatFuelType(vehicle.fuelType) },
    {
      label: 'Transmission Type',
      value: formatToSentenceCase(vehicle.transmissionType),
    },
  ]

  if (vehicle.rangeInMiles) {
    specs.push({
      rangeType: vehicle.rangeType,
      label: 'Range In Miles',
      value: `${Math.round(vehicle.rangeInMiles)} miles range`,
      icon: IconNames.info,
    })
  }

  return specs.filter(({ value }) => value !== '-' && !!value)
}
